import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import SearchPage from "@/pages/SearchPage";
import CalendarPage from "@/pages/CalendarPage";
import EducationPage from "@/pages/EducationPage";
import WriterPage from "@/pages/WriterPage";
import StoryPage from "@/pages/StoryPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminEditor from "@/pages/AdminEditor";
import AdminWriters from "@/pages/AdminWriters";
import AdminWriterEditor from "@/pages/AdminWriterEditor";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminAchievements from "@/pages/AdminAchievements";
import AdminAccounts from "@/pages/AdminAccounts";
import { VisitorTracker, CookieConsent } from "@/components/VisitorTracking";

function App() {
  return (
    <div className="min-h-screen bg-black">
      {/* Noise overlay */}
      <div className="noise-overlay" />
      
      <BrowserRouter>
        <VisitorTracker>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/article/:slug" element={<ArticlePage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/education" element={<EducationPage />} />
            <Route path="/writer/:slug" element={<WriterPage />} />
            <Route path="/story" element={<StoryPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/editor" element={<AdminEditor />} />
            <Route path="/admin/editor/:id" element={<AdminEditor />} />
            <Route path="/admin/writers" element={<AdminWriters />} />
            <Route path="/admin/writer/:id" element={<AdminWriterEditor />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/achievements" element={<AdminAchievements />} />
            <Route path="/admin/accounts" element={<AdminAccounts />} />
          </Routes>
          <CookieConsent />
        </VisitorTracker>
      </BrowserRouter>
      
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#09090b',
            border: '1px solid #27272a',
            color: '#FFFFFF',
          },
        }}
      />
    </div>
  );
}

export default App;
